const AUTH_PENDING_SESSION_INTENT_KEY = "sq:auth:pending_session_intent";

export type AuthSessionFlow =
	| "signup"
	| "login"
	| "invitation"
	| "early_access";

export type AuthSessionMethod =
	| "password"
	| "magic_link"
	| "passkey"
	| "oauth"
	| "totp";

export interface AuthPendingSessionIntent {
	flow: AuthSessionFlow;
	method: AuthSessionMethod;
	provider?: string;
}

export function stashAuthPendingSessionIntent(
	intent: AuthPendingSessionIntent,
): void {
	if (typeof window === "undefined") {
		return;
	}
	try {
		window.sessionStorage.setItem(
			AUTH_PENDING_SESSION_INTENT_KEY,
			JSON.stringify(intent),
		);
	} catch {
		// sessionStorage may be unavailable
	}
}

export function readAuthPendingSessionIntent(): AuthPendingSessionIntent | null {
	if (typeof window === "undefined") {
		return null;
	}
	try {
		const raw = window.sessionStorage.getItem(
			AUTH_PENDING_SESSION_INTENT_KEY,
		);
		if (!raw) {
			return null;
		}
		const parsed = JSON.parse(raw) as AuthPendingSessionIntent;
		if (
			(parsed.flow !== "signup" &&
				parsed.flow !== "login" &&
				parsed.flow !== "invitation" &&
				parsed.flow !== "early_access") ||
			(parsed.method !== "password" &&
				parsed.method !== "magic_link" &&
				parsed.method !== "passkey" &&
				parsed.method !== "oauth" &&
				parsed.method !== "totp")
		) {
			return null;
		}
		return parsed;
	} catch {
		return null;
	}
}

export function clearAuthPendingSessionIntent(): void {
	if (typeof window === "undefined") {
		return;
	}
	try {
		window.sessionStorage.removeItem(AUTH_PENDING_SESSION_INTENT_KEY);
	} catch {
		// ignore
	}
}
